import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Table/sgds-table-cell";
import { register } from "../../utils/ce-registry";

register("sgds-table-cell", Component);

export default createComponent({
  react: React,
  tagName: "sgds-table-cell",
  elementClass: Component,
  events: {}
});
